<template>
  <div>
    <van-nav-bar
      title="添加课程"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">
      <van-field
        clearable
        v-model="cname"
        name="cname"
        label="课程名"
        placeholder="课程名"
        :rules="[{ required: true, message: '请填写课程名' }]"
      />

      <van-field name="grade" label="年级">
        <template #input>
          <van-radio-group v-model="grade" direction="horizontal">
            <van-radio :name="item" v-for="item in grades" :key="item">{{ item }}级</van-radio>
            <van-radio name="together">不分年级</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        readonly
        clickable
        name="weekandtimes"
        :value="weekvalue+':'+timesvalue"
        label="上课时间"
        placeholder="点击选择周几"
        @click="weekshowPicker = true"
      />

      <van-popup class="popup" v-model="weekshowPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="weekColumns"
          @confirm="weekOnConfirm"
          @cancel="weekshowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        :value="startTime"
        name="startUnixTime"
        label="抢课时间"
        placeholder="点击选择抢课开始时间"
        @click="startTimeShowPicker = true"
      />

      <van-popup v-model="startTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择抢课开始时间"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="startOnConfirm"
          @cancel="startTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="tecnameandnum"
        :value="tecnameAndNumValue"
        label="教师"
        placeholder="点击选择教师"
        @click="tecnameshowPicker = true"
      />

      <van-popup class="popup" v-model="tecnameshowPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="getTecNameAndNum"
          @confirm="tecnameOnConfirm"
          @cancel="tecnameshowPicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="campusArea"
        :value="campusAreaValue"
        label="校区"
        placeholder="点击选择校区"
        @click="showCampusAreaPicker = true"
      />
      <van-popup v-model="showCampusAreaPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="campusAreaColumns"
          @confirm="campusAreaOnConfirm"
          @cancel="showCampusAreaPicker = false"
          :default-index="0"
        />
      </van-popup>
      <!--      <van-field-->
      <!--        clearable-->
      <!--        v-model="maxp"-->
      <!--        name="maxp"-->
      <!--        type="number"-->
      <!--        label="最大人数"-->
      <!--        placeholder="最大人数"-->
      <!--        :rules="[{ required: true, message: '请填写最大人数' }]"-->
      <!--      />-->

      <van-cell title="最大人数">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>


      <van-field
        v-model="introduction"
        rows="2"
        autosize
        name="introduction"
        clearable
        label="简介"
        type="textarea"
        maxlength="500"
        placeholder="课程简介"
        show-word-limit
        :rules="[{ required: true, message: '请填写课程简介' }]"
      />

      <van-row>
        <van-col span="9"></van-col>
        <van-col span="8">
          <!--          accept=".jpg,.jpeg,.png"-->
          <van-uploader v-model="fileList" :max-count="1" :before-read="before_read"
                        :after-read="after_read" :before-delete="delete_file" accept="*" multiple>
            <van-button round block icon="plus" type="primary">图片</van-button>
          </van-uploader>
        </van-col>
        <van-col span="7"></van-col>
      </van-row>


      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加课程
        </van-button>
      </div>
    </van-form>

    <div style="padding: 30px"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Dialog,
  Col,
  Row,
  DatetimePicker,
  Uploader,
  Stepper,
  Cell,
  RadioGroup,
  Radio
} from 'vant';
import {getTeacherList} from "network/teacher"
import {AddCourse} from "network/course"
import {upLoadImageToQiNiu, getToken} from "@/network/upLoader";

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
export default {
  name: "AddCourse",
  data() {
    return {
      //Course Name
      cname: '',

      grade: '2020',
      grades: [],
      //Maximum number of people
      maxp: 1,

      //Class Time
      weekvalue: '',
      timesvalue: '',
      weekshowPicker: false,
      weekColumns: [
        {
          values: ['周一', '周二', '周三', '周四', '周五'],
          defaultIndex: 0
        },
        {
          values: ['12节', '34节', '56节', '78节'],
          defaultIndex: 0
        }],
      campusAreaValue:'南校区',
      campusAreaColumns: ['南校区','济源校区'],
      showCampusAreaPicker: false,
      //Rush Course time
      startTime: '',
      startTimeShowPicker: false,
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,
      startUnixTime: '',

      //Teacher and Teacher`s number
      teachers: [],
      tecnameAndNumValue: '',
      tecnameshowPicker: false,
      columns: ['男', '女'],

      //Course introduction
      introduction: "",

      //image file
      fileList: [],
      imageSrc: ''
    };
  },
  // created() {
  //   getTeacherList().then(res => {
  //     this.teachers = [];
  //     this.teachers.push(...res);
  //   });
  // },
  activated() {
    this.grades = this.GLOBAL.grades;
    this.grade = this.GLOBAL.grade;
    getTeacherList().then(res => {
      this.teachers = [];
      this.teachers.push(...res);
    });
  },

  computed: {
    getTecNameAndNum() {
      if (this.$cookies.get("user") === "admin") {
        return this.teachers.map(value => value.id + ':' + value.tName + ':' + value.tNum + ':' + value.gender);
      } else {
        let booleans = this.teachers.filter(value => value.id == this.$cookies.get("info").id);
        return booleans.map(value => value.id + ':' + value.tName + ':' + value.tNum + ':' + value.gender);
      }
    }
  }
  ,
  methods: {
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("CourseList");
    }
    ,
    onSubmit(values) {
      let times = new Date();
      let creatDate = times.getFullYear() + '-' + (times.getMonth() + 1) + '-' + times.getDate() + '-' + times.getHours() + '-' + times.getMinutes() + '-' + times.getSeconds() + ':' + times.getTime();
      if (values.weekandtimes === ":") {
        this.Dialoginfo('提示', '时间不能为空');
      } else if (values.startUnixTime === "") {
        this.Dialoginfo('提示', '抢课开始时间不能为空');
      } else if (values.tecnameandnum === "") {
        this.Dialoginfo('提示', '教师不能为空');
      } else if (values.introduction === "") {
        this.Dialoginfo('提示', '介绍不能为空');
      } else if (this.imageSrc === "") {
        this.Dialoginfo('提示', '二维码不能为空');
      } else {
        let wt = values.weekandtimes.split(':');
        let tn = values.tecnameandnum.split(':');
        AddCourse(values.cname, values.grade, wt[0], wt[1], tn[0], tn[1], tn[2], tn[3], this.maxp, this.introduction, this.imageSrc, this.startUnixTime, creatDate,values.campusArea).then(res => {
          if (res) {
            this.Dialoginfo('提示', '添加成功');
            this.maxp = 0;
            this.cname = "";
          } else {
            this.Dialoginfo('提示', '添加失败');
          }
        });
      }
    }
    ,
    weekOnConfirm(value) {
      this.weekvalue = value[0];
      this.timesvalue = value[1];
      this.weekshowPicker = false;
    }
    ,
    tecnameOnConfirm(value) {
      this.tecnameAndNumValue = value;
      this.tecnameshowPicker = false;
    },
    campusAreaOnConfirm(value) {
      this.campusAreaValue = value;
      this.showCampusAreaPicker = false;
    },
    startOnConfirm(value) {
      this.startUnixTime = value.getTime().toString();
      this.startTime = value.toLocaleString();
      this.startTimeShowPicker = false;
    },
    before_read(file) {
      // console.log(file);
      let dot = file.name.split(".");
      let fileType = dot[dot.length - 1];
      if (fileType !== 'jpg' && fileType !== 'jpeg' && fileType !== 'png') {
        Dialog.alert({
          message: '请上传 jpg,jpeg,jpeg 格式文件',
        });
        return false;
      } else if (file.size > 10039264) {
        Dialog.alert({
          message: '文件过大,请保持在10M以内',
        });
        return false;
      }
      return true;
    },
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      getToken().then(res => {
        data.append('token', res);     //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
        // data.append('token', 'u6no7aFYuEeuEw6cIc3dB82YTeC_K3RnbWa78RA_:2c3JexJjS32mLROcJHD2p9Zs9s0=:eyJzY29wZSI6Imhoc3R1LXNwb3J0cyIsImRlYWRsaW5lIjoxNTk3NzQ3ODIzfQ==');     //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
        // data.append('file', file);
        data.append("file", file.file);
        upLoadImageToQiNiu(data).then(data => {
          // console.log(data);
          this.imageSrc = 'http://cdn.sport.hhstu.club/' + data.data.key;
          file.status = 'done';
          file.message = '导入成功';
        }).catch(function (err) {
          file.status = 'failed';
          file.message = '导入失败';
        });

      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })


    },
    delete_file() {
      this.fileList = [];
      return true;
    },
  }
  ,
}
</script>

<style scoped>
.scroll {
  overflow-y: scroll;
  height: 100%;
}

.popup {
  z-index: 10002;
}
</style>
